export default "__VITE_ASSET__B6$cd8ya__"